import { useTranslation } from "react-i18next"
import SimpleSelectFilter from "../../../../../../../commons/simple-select-filter"

const FilterNightsQuantities = ({ data }) => {
  const { t } = useTranslation("translations")

  return (
    <SimpleSelectFilter
      name="nightsQuantity"
      data={data}
      mapOptionRender={(nightsQuantity) => (
        <option
          key={nightsQuantity}
          value={nightsQuantity}
        >{`${nightsQuantity} ${t("filters.nightW")}`}</option>
      )}
    />
  )
}

export default FilterNightsQuantities
